import React from "react";

export default function Required() {
  return (
    <>
      * <span>(obrigatório)</span>
    </>
  );
}
